import { jsx } from 'react/jsx-runtime';
import { useSensors, useSensor, PointerSensor, KeyboardSensor, DndContext, closestCenter } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { DraggableItem } from './Draggable.Item/Draggable.Item.es.js';
import { DraggableList } from './Draggable.List/Draggable.List.es.js';

const Draggable = ({ children, dragDistance = 8, ...rest })=>{
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {
            distance: dragDistance
        }
    }), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates
    }));
    return jsx(DndContext, {
        collisionDetection: closestCenter,
        sensors: sensors,
        ...rest,
        children: children
    });
};
Draggable.List = DraggableList;
Draggable.Item = DraggableItem;
Draggable.displayName = 'Draggable';

export { Draggable, Draggable as default };
//# sourceMappingURL=Draggable.es.js.map
